import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

export enum BREAKPOINTS {
    // These are from _breakpoints.scss
    XSMALL = 360,
    SMALL = 460,
    MEDIUM = 768,
    LARGE = 1024,
    XLARGE = 1200,
}

@Injectable({
    providedIn: 'root',
})
export class BreakpointService {
    private currentBreakpointState$ = new BehaviorSubject<Partial<BreakpointState>>({});

    constructor(private breakpointObserver: BreakpointObserver) {
        const breakpoints = Object.values(BREAKPOINTS)
            .filter((b) => typeof b === 'number')
            .map((k) => `(min-width: ${k}px)`);

        this.breakpointObserver.observe(breakpoints).subscribe((result) => {
            this.currentBreakpointState$.next(result);
        });
    }

    matchBreakpoint(breakpoint: BREAKPOINTS) {
        return this.currentBreakpointState$.pipe(
            map((state) => state?.breakpoints?.[Object.keys(state.breakpoints).find((bp) => bp.includes(`${breakpoint}`)) || ''])
        );
    }
}
